import React from 'react'

const WorkingProcess = ({ workingProcesses }: { workingProcesses: any }) => {
    return (
        <div className="process-wrap wow fadeInUp" data-wow-delay=".25s">
            <div className="row g-4 d-flex justify-content-center">
                {
                    workingProcesses?.map((processOne: any, index: number) =>
                        <div className="col-md-6 col-lg-4 col-xl-3" key={index}>
                            <ProcessCard processOne={processOne} index={index} />
                        </div>
                    )
                }
                {/* <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="process-item">
                        <span className="count">Step - 01</span>
                        <div className="icon">
                            <img src="../assets/img/icon/hybrid.svg" alt="" />
                        </div>
                        <div className="content">
                            <h4>Choose Service</h4>
                            <p>
                                It is a long established fact that a reader will be
                                distracted by the readable content of a page.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="process-item">
                        <span className="count">Step - 02</span>
                        <div className="icon">
                            <img src="../assets/img/icon/consult.svg" alt="" />
                        </div>
                        <div className="content">
                            <h4>Free Consultant</h4>
                            <p>
                                It is a long established fact that a reader will be
                                distracted by the readable content of a page.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="process-item">
                        <span className="count">Step - 03</span>
                        <div className="icon">
                            <img src="../assets/img/icon/plan.svg" alt="" />
                        </div>
                        <div className="content">
                            <h4>Planing &amp; Analysis</h4>
                            <p>
                                It is a long established fact that a reader will be
                                distracted by the readable content of a page.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="process-item">
                        <span className="count">Step - 04</span>
                        <div className="icon">
                            <img src="../assets/img/icon/install-3.svg" alt="" />
                        </div>
                        <div className="content">
                            <h4>Mechine Installation</h4>
                            <p>
                                It is a long established fact that a reader will be
                                distracted by the readable content of a page.
                            </p>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    )
}

const ProcessCard = ({ processOne, index }: { processOne: any, index: number }) => {
    return (
        <div className="process-item">
            <span className="count">Step - {index + 1}</span>
            <div className="icon">
                {/* <img src="../assets/img/icon/hybrid.svg" alt="" /> */}
                <i className={`${processOne?.icon_class} icon-size-lg`}></i>
            </div>
            <div className="content">
                <h4>{processOne?.name}</h4>
                <p>
                    {processOne?.description}
                </p>
            </div>
        </div>
    )
}


export default WorkingProcess
